var fn = function( obj ){
var __t,__p='';
__p+='\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\n\nuniform mat4 uIMVP;\nuniform float uTime;\n\nvarying vec3 vView;\nvarying vec2 vTexcoord;\n\nvoid main(void){\n\n  gl_Position.xy = aPosition;\n  gl_Position.zw = vec2(1.0,1.0);\n\n  vec4 pos = vec4(aPosition.xy, 1.0, 1.0);\n\n  vView = (uIMVP * pos).xyz;\n  vView.x += uTime;\n  vTexcoord = aTexCoord * 20.0;\n\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;